<script lang="ts">
import { defineComponent } from '@vue/composition-api';
// @ts-ignore
import VClamp from 'vue-clamp';

interface IProps {
    maxLines: number;
    autoresize: boolean;
    customStyles: string;
}

const AppClamp = defineComponent<IProps>({
    name: 'AppClamp',
    components: { VClamp },
    props: {
        maxLines: Number,
        autoresize: Boolean,
        customStyles: String,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        return {};
    },
});

export default AppClamp;
</script>

<template>
  <v-tooltip top>
    <template #activator="{on}">
      <div v-on="on">
        <v-clamp
          :autoresize="autoresize"
          :max-lines="maxLines"
          :style="customStyles"
        >
          <slot />
        </v-clamp>
      </div>
    </template>
    <slot />
  </v-tooltip>
</template>

<style lang="scss" scoped></style>
